/**
 * FinanzePanoramica Page - Page Shell
 * Dashboard finanze
 */

import { FinanceDashboard } from "@/features/finanze";

export default function FinanzePanoramica() {
  return <FinanceDashboard />;
}
